import invariant from 'invariant';

import { configString } from '#/config/appConfigUtils';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';
import { isNotEmpty } from '#/utils/functional/poly';

type Args = {
  sort: SearchSortType;
};

export function searchAlgoliaVolopsIndex({ sort }: Args) {
  const volopsIndexName = configString('algolia', 'volopsIndexName');
  invariant(isNotEmpty(volopsIndexName), 'volopsIndexName cannot be empty');

  if (sort === 'relevance') return volopsIndexName;

  return `${volopsIndexName}-published-desc`;
}
